import React from 'react';
import QuoteRequestForm, { BrochureBtn, ImgRender, VideoButton } from '../BFComponents';

export default function FireKing() {
    return (
        <div className="container">
            <div className="fireking-logo">
                <div className="row">
                    <div className="col-md-6 col-lg-3">
                        <ImgRender image={"fire-king-logo.svg"} width={100} />
                    </div>
                </div>
            </div>
            <div className="row my-3">
                <div className="col-lg-8">
                    <div className="fireking-intro">
                        <div className="fireking-intro1">
                            <h1>PROTECT WHAT'S IMPORTANT</h1>
                        </div>

                        <div className="fireking-intro2">
                            For over six decades, FireKing International has been providing high-quality products designed to protect your company's vital business records. FireKing offers a broad array of products that are manufactured or created using the most innovative, advanced product development technology available.
                            </div>

                    </div>
                </div>
                <div className="col-lg-4">
                    <VideoButton id={"VhBHiZ8TcQ7c"} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 d-flex justify-content-center">
                    <div className="d-flex flex-column align-items-center">
                        <div>
                            <ImgRender image={"fireking.jpg"} width={100} />
                        </div>
                        <QuoteRequestForm source={window.location} />
                        <BrochureBtn brochure={"Fireking Four Drawer Legal Filing Cabinet NAMCo.pdf"} />
                    </div>
                </div>
                <div className="col-md-6">
                    <ol>
                        <li>
                            <strong>FIREPROOF INSULATION</strong><br />
is 100% gypsum, reinforced by a
1" by 2" lattice made of 14-gauge
galvanized welded steel wire,
providing complete peace of mind
from fire, impact, or explosion.

                    </li>
                        <li>
                            <strong>FIELD REPLACEABLE
STEEL PANELS</strong><br />

can easily be replaced in the
event that any panel is damaged.

                    </li>
                        <li>
                            <strong>FINISH</strong><br />
                            is an environmentally-friendly
electrostatic powder coating
applied to all sides, including
bottom. The finish is scratchresistant, providing a lifetime
quality appearance.

                    </li>
                        <li>
                            <strong>DRAWER BODIES</strong><br />
                            are built with high sides for
use with hanging folders – no
additional frames are needed.

                    </li>
                        <li>
                            <strong>DRAWER SUSPENSIONS</strong><br />
                            are maintenance free and are
guaranteed for life.

                    </li>
                        <li>
                            <strong>DRAWER LOCKS</strong><br />
                            on all files provide general
locking of all drawers through
either standard key locks or
UL®-listed high-security locks.

                    </li>
                        <li>
                            <strong>DRAWER PULLS</strong><br />
                            are surface mounted to allow
for extra insulation inside the
drawer heads.

                    </li>
                        <li>
                            <strong>INSULATION BETWEEN ALL DRAWERS</strong><br />
                            makes each drawer a
separate insulated container.

                    </li>
                        <li>
                            <strong>2-POSITION DRAWER CATCH</strong><br />
                            allows access to certain
drawers while others
remain locked.

                    </li>
                        <li>
                            <strong>DRAWER HEADS</strong><br />
                            are formed of welded steel and
filled with fireproof insulation,
and are field replaceable.

                    </li>
                        <li>
                            <strong>UNDERWRITERS
                            LABORATORIES® (UL®)
FIRE & IMPACT RATING</strong><br />

on all file cabinets.
See back for details.

                    </li>
                    </ol>
                </div>
            </div>

            <div className="row d-flex justify-content-between">
                <div className="col-md-2 d-flex flex-column justify-content-center text-center">
                    <ImgRender image={"f5.jpg"} width={100} />
                    <strong><h5>STORAGE CABINET</h5></strong>72" high – 4 shelves<br />44" high – 2 shelves
                </div>
                <div className="col-md-2 d-flex flex-column justify-content-center text-center">
                    <ImgRender image={"f4.jpg"} width={100} />
                    <strong><h5>VERTICAL</h5></strong>25" or 31" Depth<br />Choose Legal or Letter<br />2, 3, or 4 Drawers
                </div>
                <div className="col-md-2 d-flex flex-column justify-content-center text-center">
                    <ImgRender image={"f3.jpg"} width={100} />
                    <strong><h5>LATERAL</h5></strong>31", 38" or 44" Widths<br />2, 3, or 4 Drawers
                </div>
                <div className="col-md-2 d-flex flex-column justify-content-center text-center">
                    <ImgRender image={"f2.jpg"} width={100} />
                    <strong><h5>TURTLE®</h5></strong>22" Depth<br />Letter/Legal Filing<br />2 or 4 Drawers
                </div>
                <div className="col-md-2 d-flex flex-column justify-content-center text-center">
                    <ImgRender image={"f1.jpg"} width={100} />
                    <strong><h5>MEDIAVAULT™</h5></strong>Protection for Data/Computer Media
                </div>
            </div>
            <div id="fk-icons" className="p-2">
                <h5>Look for these icons when choosing the right product for your business:</h5>
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-3">
                                <ImgRender image={"fk1.svg"} width={100} />
                    Underwriters Laboratories
Class 350 1-hr. Insulated
Records Container
</div>
                            <div className="col-md-3">
                                <ImgRender image={"fk2.svg"} width={100} />
                                Underwriters Laboratories
Class 350 2-hr. Insulated
Records Container
</div>
                            <div className="col-md-3">
                                <ImgRender image={"fk4.svg"} width={100} />
                                Underwriters Laboratories
Class 125 1-hr. Insulated
Records Protection for
Computer Media
</div>
                            <div className="col-md-3">
                                <ImgRender image={"fk5.svg"} width={100} />
                                Underwriters Laboratories
Explosion Hazard Rating
</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-3">
                                <ImgRender image={"fk3.svg"} width={100} />
                                Underwriters Laboratories
Impact Rating
</div>
                            <div className="col-md-3">
                                <ImgRender image={"fk6.svg"} width={100} />
                                Medeco® Key Lock
                                Underwriters Laboratories
Listed to resist picking
and drilling
</div>
                            <div className="col-md-3">
                                <ImgRender image={"fk7.svg"} width={100} />
                                All FireKing files are
designed to prevent water
damage resulting from
sprinklers and fire hoses
</div>
                            <div className="col-md-3">
                                <ImgRender image={"fk8.svg"} width={100} />
                Theft Resistant
</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}